import React from 'react';

export const TASKS_SECTION_TITLE = 'Simplify Guest Communication';

export const TASK_PROPS_MESSAGE_GUESTS = {
  title: 'Message guests',
  content: <div>Send quick mass emails or texts to collect addresses and more.</div>,
  onClick: analyticsStore => {
    analyticsStore.track('Share Website Initiated', {
      page: 'guest list',
      action: 'message guests',
      selection: 'Message guests',
    });
    window.location.assign('/gs/dashboard/messaging-hub?source=/our-guest-list');
  },
};

export const TASK_MESSAGE_GUESTS = {
  title: 'Message guests',
  content: <div>Share your website, remind guests to RSVP and more.</div>,
  onClick: analyticsStore => {
    analyticsStore.track('Share Website Initiated', {
      action: 'message guests',
      source: 'guest list',
      selection: 'Message guests',
    });
    window.location.assign('/gs/dashboard/messaging-hub?source=/our-guest-list');
  },
};

export const TASK_FREE_INVITATION_SAMPLES = {
  title: 'Get free invite samples',
  content: <div>See and feel our quality paper and beautiful designs up close.</div>,
  onClick: analyticsStore => {
    analyticsStore.track('Free Invitation Samples', {
      action: 'free-invitation-samples',
      source: 'guest list',
      selection: 'Get free invitation samples',
    });
    window.open('/paper/free-samples', '_blank') || window.location.assign('/paper/free-samples');
  },
};

export const TASK_INVITATION_AND_PAPERS = {
  title: 'See invitations & paper',
  content: <div>Share the most important details with designs that feel like you.</div>,
  onClick: analyticsStore => {
    analyticsStore.track('Invitations and Paper', {
      action: 'invitations-and-paper',
      source: 'guest list',
      selection: 'See invitations & paper',
    });
    window.open('/paper/invitations/wedding', '_blank') || window.location.assign('/paper/invitations/wedding');
  },
};

export const TASK_PROPS_START_WWS = {
  title: 'Start your free website',
  content: <div>Make it easy for guests to RSVP, see event details and shop for gifts.</div>,
  onClick: analyticsStore => {
    analyticsStore.track('Dashboard Interaction', {
      action: 'wws onboarding',
      source: 'guest list',
      selection: 'Start your free website',
    });
    window.location.assign('/gs/wedding-websites/designs');
  },
};

export const TASK_PROPS_UNSTARTED_RSVPS = {
  title: 'Set up RSVPs',
  content: <div>Customize your website's RSVP page to easily collect and track responses.</div>,
  onClick: analyticsStore => {
    analyticsStore.track('RSVP Settings Interaction', {
      action: 'start workflow',
      source: 'guest list',
      selection: 'Set up RSVPs',
    });
    window.location.assign('/gs/dashboard/rsvp-workflow?referrerRedirectPath=/our-guest-list');
  },
};

export const TASK_PROPS_STARTED_RSVPS = {
  title: 'Edit your RSVP page',
  content: <div>Add events, adjust RSVP settings or edit questions for your guests.</div>,
  onClick: analyticsStore => {
    analyticsStore.track('Dashboard Interaction', {
      action: 'RSVP Settings Initiated',
      source: 'guest list',
      selection: 'Edit your RSVP page',
    });
    window.location.assign('/our-guest-list/rsvp-settings');
  },
};

export const TASK_PROPS_LOOKING_FOR_HOTELS_INFO_CARD = {
  title: 'Reserve room blocks',
  content: 'Find hotels with group rates for your out-of-town guests.',
  footer: React.createElement(
    'div',
    { style: { paddingTop: '8px' } },
    'Powered by ',
    React.createElement('img', {
      src: 'https://media-api.xogrp.com/images/cbb83f7a-844a-4237-a285-74c6175c9bdc',
      alt: 'Engine',
      style: { height: '14px', verticalAlign: 'middle', display: 'inline' },
    })
  ),
  onClick: analyticsStore => {
    analyticsStore.track('Dashboard Interaction', {
      action: 'hotel block',
      source: 'guest list',
      selection: 'engine cta',
    });
    window.open(
      'https://theknot.partners.engine.com/new-trip?utm_source=the-knot&utm_medium=channel&utm_ca[…]rm=tkguestlist&referral=MKT%20-%20Partner&rel=sponsored',
      '_blank'
    );
  },
  dataTestid: 'reserve-room-blocks-task',
  ariaLabel: 'Reserve room blocks',
};
